import { useTranslate } from '@/translations';
import { DamageExceptionVehicleModel } from '@/types';
import { localDateFormatted } from '@/utils/helpers';
import { Descriptions, Divider } from 'antd';
import React, { FC } from 'react';

interface VehicleDetailProps {
  vehicle: DamageExceptionVehicleModel;
}
export const VehicleDetail: FC<VehicleDetailProps> = ({ vehicle }) => {
  const { t } = useTranslate();

  const rowItems = [
    {
      key: 0,
      label: t('vin').toUpperCase(),
      children: vehicle.vin,
    },
    {
      key: 1,
      label: t('manufacturer'),
      children: vehicle.manufacturer,
    },
    { key: 2, label: t('vehicle'), children: vehicle.model },
    {
      key: 3,
      label: t('year'),
      children: vehicle.manufactureDate
        ? vehicle.manufactureDate.split('-')[0]
        : null,
    },
    { key: 4, label: t('colour'), children: vehicle.colour },
    { key: 5, label: t('regNumber'), children: vehicle.regNumber },
    { key: 6, label: t('site'), children: vehicle.locationDesc },
    { key: 7, label: t('location'), children: vehicle.location },
    { key: 8, label: t('status'), children: vehicle.vinStatus },
    {
      key: 9,
      label: t('statusDescription'),
      children: vehicle.vinStatusDesc,
    },
    {
      key: 10,
      label: t('manufacturedDate'),
      children: vehicle.manufactureDate
        ? localDateFormatted(vehicle.manufactureDate)
        : null,
    },
  ];

  return (
    <>
      <Divider>Vehicle Detail</Divider>
      <Descriptions
        className="light-content"
        bordered
        size="small"
        column={1}
        items={rowItems}
      />
    </>
  );
};
